import Vue from 'vue';
import {initWebsocket} from "@/utils/websocket/websocket.js";

Vue.prototype.displayingNuxtError = false;

export default async (context) => {
	window.__NUXT__.logs = [];
	await context.store.dispatch('nuxtClientInit', context)
	if(process.browser){
		initWebsocket();
	}
}
